"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("./helpers");
var TriggerClass_1 = __importDefault(require("./TriggerClass"));
var Exit = /** @class */ (function (_super) {
    __extends(Exit, _super);
    function Exit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.throttlePause = false;
        _this.lastScrollY = 0;
        _this.scrollPercentageThreshold = 80;
        _this.scrollPercentageDelta = -80;
        _this.touchActionHandler = function (actionCallback) {
            _this.mouseActionHandler(actionCallback);
            (0, helpers_1.bindEvent)(window, 'touchstart', function () {
                if (_this.hasRendered)
                    return;
                _this.lastScrollY = window.scrollY;
            });
            (0, helpers_1.bindEvent)(window, 'scroll', function () {
                if (_this.isDeprecated || _this.hasRendered || _this.throttlePause)
                    return;
                _this.throttlePause = true;
                setTimeout(function () {
                    var scrollPercentage = Math.round((window.scrollY / window.innerHeight) * 100);
                    var scrollDelta = window.scrollY - _this.lastScrollY;
                    var thresholdReached = scrollPercentage >= _this.scrollPercentageThreshold;
                    if (thresholdReached && scrollDelta <= _this.scrollPercentageDelta) {
                        actionCallback();
                        _this.hasRendered = true;
                    }
                    _this.throttlePause = false;
                }, 50);
                _this.lastScrollY = window.scrollY;
            });
        };
        _this.mouseActionHandler = function (actionCallback) {
            var HTMLElement = document.getElementsByTagName('html')[0];
            (0, helpers_1.bindEvent)(HTMLElement, 'mouseleave', function (e) {
                if (_this.isDeprecated || _this.hasRendered)
                    return;
                var exitTop = window.innerHeight < e.clientY;
                var exitBottom = e.clientY < 0;
                var exitRight = window.innerWidth < e.clientX;
                var exitLeft = e.clientX < 0;
                if (exitTop || exitBottom || exitLeft || exitRight) {
                    actionCallback();
                    _this.hasRendered = true;
                }
            });
        };
        return _this;
    }
    Exit.prototype.init = function (actionCallback) {
        'ontouchstart' in window ? this.touchActionHandler(actionCallback) : this.mouseActionHandler(actionCallback);
    };
    Exit.prototype.toString = function () {
        return 'Trigger exit intent';
    };
    return Exit;
}(TriggerClass_1.default));
exports.default = Exit;
//# sourceMappingURL=data:application/json;base64,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